import React from "react";
import "./Portfolio.css";

function Portfolio() {
  const data = [
    {
      id: 1,
      image: "../assets/portfolio1.jpg",
      title: "Crypto currency dashboard ",
      github: "https://github.com",
      demo: "https://",
    },
    {
      id: 2,
      image: "../assets/portfolio2.jpg",
      title: "Crypto currency dashboard ",
      github: "https://github.com",
      demo: "https://",
    },
    {
      id: 3,
      image: "../assets/portfolio3.jpg",
      title: "Crypto currency dashboard ",
      github: "https://github.com",
      demo: "https://",
    },
    {
      id: 4,
      image: "../assets/portfolio4.jpg",
      title: "Crypto currency dashboard ",
      github: "https://github.com",
      demo: "https://",
    },
    {
      id: 5,
      image: "../assets/portfolio5.png",
      title: "Crypto currency dashboard ",
      github: "https://github.com",
      demo: "https://",
    },
    {
      id: 6,
      image: "../assets/portfolio6.jpg",
      title: "Crypto currency dashboard ",
      github: "https://github.com",
      demo: "https://",
    },
  ];

  return (
    <section id="portfolio">
      <h5>My Recent Work</h5>
      <h2>Portfolio</h2>

      <div className="container portfolio__container">
        {data.map(({ id, image, title, github, demo }) => {
          return (
            <article key={id} className="portfolio__item">
              <div className="portfolio__item-image">
                <img src={image} alt={title} />
              </div>
              <h3>{title}</h3>
              <div className="portfolio__item-cta">
                <a href={github} className="btn">
                  Github
                </a>
                <a
                  href={demo}
                  className="btn btn-primary"
                
                >
                  Live Demo
                </a>
              </div>
            </article>
          );
        })}
      </div>
    </section>
  );
}

export default Portfolio;
